export interface ActivationBaselineSubscription {
  name: string;
  label: string;
  skuRule: {
    SL: string;
    IS?: string;
  };
  hidden: boolean;
}

export const activationBaselineSubscriptions: ActivationBaselineSubscription[] = [
  {name: "BASIC", label:"Luckey Basic", skuRule: { SL: "018S" }, hidden: false},
  {name: "ENTERPRISE", label:"Luckey Enterprise", skuRule:{ SL: "001S", IS: "004S" } , hidden: false},
  {name: "ENGINE", label:"Luckey Engine", skuRule:{ SL: "024S" }, hidden: false},
  {name: "ESSENTIAL", label:"Luckey Essential", skuRule:{ SL: "025S" }, hidden: false},
];
